import React from "react";

type RenderFunction<T> = (
  value: any,
  record: T,
  rowIndex: number
) => React.ReactNode;

interface ColumnDefinition<T> {
  title: string;
  dataIndex?: keyof T; // for direct mapping
  render?: RenderFunction<T>; // for custom cell rendering
  className?: string; // optional cell/class styling
}

interface TableProps<T> {
  columns: Array<ColumnDefinition<T>>;
  data: T[];
  tableClassName?: string;
  headClassName?: string;
  bodyClassName?: string;
}

function Table<T>({
  columns,
  data,
  tableClassName = "table w-full",
  headClassName = "",
  bodyClassName = "",
}: TableProps<T>) {
  return (
    <div className="table-wrapper">
      <table className={tableClassName}>
        <thead>
          <tr className={headClassName}>
            {columns.map((col, colIndex) => (
              <th key={colIndex} className={col.className}>
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={bodyClassName}>
          {data.map((item, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => {
                // If a render function exists, use it. Otherwise, map directly from dataIndex
                const cellValue = col.dataIndex ? item[col.dataIndex] : "";
                return (
                  <td key={colIndex} className={col.className}>
                    {col.render
                      ? col.render(cellValue, item, rowIndex)
                      : (cellValue as React.ReactNode)}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
